//#region Libraries
import { useState } from "react";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import FooterButtons from "../../components/FooterButtons/FooterButtons";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import DialogAlertErrorNotify from "components/DialogAlertNotify/DialogAlertErrorNotify/DialogAlertErrorNotify";
//#endregion
//#region Services
import { 
    requestCreateGroupRoomResource, 
    requestUpdateGroupRoomResource } from "services/resources/library/aboutLibraryResources";
//#endregion
//#region Utils
import useMainContext from "utils/context/useMainContext";
import { RESOURCE_TEXT_LIST } from "views/Recursos/ResourcesLibrary/utils/constants";
import { ERROR_TEXT_LIST, GROUP_ROOM_SERVICE_TYPE_ID, PROPS_CONTENT_DIALOG_ALERT_NOT_UPDATE_FOR_FUTURE_RESERVATION_WHEN_CHANGES_CAPACITY } from "../utils/constants";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { ERROR_MESSAGES_IN_UPDATE_RESOURCE_REQUEST } from "../utils/constants";
//#endregion

const RESOURCE_GROUP_ROOM_TEXT_LIST = RESOURCE_TEXT_LIST[GROUP_ROOM_SERVICE_TYPE_ID];

const Footer = ({
    isAdmin,
    closeFormDialog,
    toggleShowDialogDeletionResource,
    form, errors, changeErrorTexts,
    loadingRequest,
    filtersAreCompleted,
    fillServiceList,
    isCreate
}) => {
    const mainContext = useMainContext();
    //#region States
    const [contentPropsDialogSaveChanges, setContentPropsDialogSaveChanges] = useState({
        title: "",
        contentComponent: null
    });
    //#endregion
    const dialogShowSaveChanges = useShowDialogAlert();
    const dialogShowNotUpdateForFutureReservationsWhenChangesCapacity = useShowDialogAlert();
    //#region Functions
    const openDialogSaveChanges = () => {
        const isCompleted = form.isCompleted();
        if (!isCompleted) return;
        // Abriendo modal de confirmación de guardado de cambios
        dialogShowSaveChanges.toggle(true);
        const { name } = form.value;
        if (isCreate) {
            setContentPropsDialogSaveChanges({
                title: `¿Deseas registrar el recurso ${name}?`,
                contentComponent: (
                    <p className="paragraph">
                        Recuerda que podrás visualizarlo en la pantalla principal.
                    </p>
                )
            });
            return;
        }
        setContentPropsDialogSaveChanges({
            title: `¿Deseas guardar el cambio en el recurso ${name}?`,
            contentComponent: (
                <p className="paragraph">
                    Recuerda que podrás visualizar los cambios en la opción <b>Editar.</b>
                </p>
            )
        });
    }
    const saveData = async () => {
        // No eliminar al alumno responsable deshabilitar
        const resourceTypeName = RESOURCE_GROUP_ROOM_TEXT_LIST.minus.singular;
        // Realizando petición de creación o actualización
        const params = isCreate 
            ? {
                request: requestCreateGroupRoomResource,
                loadingRequestMsg: `Registrando ${resourceTypeName}...`, 
                toastMessage: `¡Se agregó con exito el registro de ${resourceTypeName}!`
            }
            : {
                request: requestUpdateGroupRoomResource,
                loadingRequestMsg: `Actualizando ${resourceTypeName}...`, 
                toastMessage: `¡Actualización con éxito de ${form.value.name}!`
            };
        loadingRequest.show(params.loadingRequestMsg);
        const { success, message } = await params.request(form.value);
        loadingRequest.hide();
        // Gestionando respuesta
        if (success) {
            // Exitosa
            closeFormDialog();
            fillServiceList({
                messageForToast: params.toastMessage, 
                noFill: !filtersAreCompleted()
            });
            return;
        }
        dialogShowSaveChanges.toggle(false); 
        // Fallida
        if (manageFailedRequest(message)) 
            return;
        // Error inesperado
        mainContext.setShowDialogUnexpectedError(true);
    }
    const manageFailedRequest = message => {
        if (message === ERROR_MESSAGES_IN_UPDATE_RESOURCE_REQUEST.FUTURE_RESERVATIONS) {
            dialogShowNotUpdateForFutureReservationsWhenChangesCapacity.set(true);
            changeErrorTexts({
                capacity: ERROR_TEXT_LIST.CAPACITY.INVALID_FOR_FUTURE_RESERVATIONS
            });
            errors.change({ capacity: true });
            return true;
        }
        return false;
    }
    const getDisabledSaveButton = () => {
        return !form.areThereChanges() || !form.isCompleted() || errors.areThere();
    }
    //#endregion
    const canDelete = !isCreate && isAdmin;
    return (
        <>
        <FooterButtons 
            canDelete={canDelete}
            showDialogNotUpdateForFutureReservationsWhenChangesCapacity={dialogShowNotUpdateForFutureReservationsWhenChangesCapacity.value}
            actions={{
                doSave: openDialogSaveChanges,
                doCancel: closeFormDialog,
                doDelete: () => toggleShowDialogDeletionResource(true)
            }}
            form={form}
            getDisabledSaveButton={getDisabledSaveButton}/>
        <DialogAlertAction
            minWidth="590px"
            widthContent="90%"
            spacingContainer="25px"
            variant="secondary"
            show={dialogShowSaveChanges.value}
            toggleShow={dialogShowSaveChanges.toggle}
            {...contentPropsDialogSaveChanges}>
            <CustomButton
                variant="secondary"
                size="medium"
                text="No, cancelar"
                width="110px"
                onClick={() => dialogShowSaveChanges.toggle(false)}/>
            <CustomButton
                size="medium"
                text="Sí, guardar"
                width="110px"
                onClick={saveData}/>
        </DialogAlertAction>
        <DialogAlertErrorNotify 
            show={dialogShowNotUpdateForFutureReservationsWhenChangesCapacity.value}
            toggleShow={dialogShowNotUpdateForFutureReservationsWhenChangesCapacity.toggle}
            content={PROPS_CONTENT_DIALOG_ALERT_NOT_UPDATE_FOR_FUTURE_RESERVATION_WHEN_CHANGES_CAPACITY}>
            <CustomButton
                text="Cerrar"
                onClick={() => dialogShowNotUpdateForFutureReservationsWhenChangesCapacity.set(false)}/>
        </DialogAlertErrorNotify>
        </>
    );
}

export default Footer;